var map = {
	"./accounts/accounts.module": [
		"./src/app/rms/accounts/accounts.module.ts",
		"default~accounts-accounts-module~inventory-inventory-module~reports-reports-module",
		"default~accounts-accounts-module~rms-rms-module",
		"common",
		"accounts-accounts-module"
	],
	"./configurations/configurations.module": [
		"./src/app/rms/configurations/configurations.module.ts",
		"common",
		"configurations-configurations-module"
	],
	"./inventory/inventory.module": [
		"./src/app/rms/inventory/inventory.module.ts",
		"default~accounts-accounts-module~inventory-inventory-module~reports-reports-module",
		"common",
		"inventory-inventory-module"
	],
	"./ola-mgmt/ola-mgmt.module": [
		"./src/app/rms/ola-mgmt/ola-mgmt.module.ts",
		"ola-mgmt-ola-mgmt-module"
	],
	"./reports/reports.module": [
		"./src/app/rms/reports/reports.module.ts",
		"default~accounts-accounts-module~inventory-inventory-module~reports-reports-module",
		"common",
		"reports-reports-module"
	],
	"./rms/rms.module": [
		"./src/app/rms/rms.module.ts",
		"default~accounts-accounts-module~rms-rms-module",
		"common",
		"rms-rms-module"
	],
	"./roles-mgmt/roles-mgmt.module": [
		"./src/app/rms/roles-mgmt/roles-mgmt.module.ts",
		"roles-mgmt-roles-mgmt-module"
	],
	"./user-mgmt/user-mgmt.module": [
		"./src/app/rms/user-mgmt/user-mgmt.module.ts",
		"common",
		"user-mgmt-user-mgmt-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;